import React, { useEffect, useState } from 'react';
import StudentWrapper from '../../StudentWrapper';
import Button from '../../../components/Button';
import AddPayment from '../addPayment/AddPayment';
import { Link, useParams } from 'react-router-dom/dist';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/Loader/Loader';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; // For spinner icon
import moment from 'moment';
import Reviews from '../Reviews/Reviews';
import Input from '../../../components/Input';

const EnrolledCourseDetails = () => {
  const [open, setOpen] = useState(false);
  const [courseDetails, setCourseDetails] = useState();
  console.log(courseDetails);

  const [classCount, setClassCount] = useState('');
  const [absent, setAbsent] = useState('');
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    fetchCourseDetails(id);
  }, [id]);

  const fetchCourseDetails = (courseId) => {
    const user = JSON.parse(localStorage.getItem('userData'));

    setLoader(true);

    if (!user) {
      setLoader(false);
      toast.error('User data not found in local storage.');
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      email: user?.email,
      courseId: courseId
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/signle-enrolled-course', requestOptions)
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        let data = JSON.parse(result);
        setLoader(false);

        if (data?.success === true) {
          setCourseDetails(data?.data);
        } else {
          toast.error(data?.message || 'An error occurred while fetching course details.');
        }
      })
      .catch((error) => {
        setLoader(false);
        console.error(error);
        toast.error(`Error: ${error.message}`);
      });
  };

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      email: data?.email,
      courseId: id
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/signle-enrolled-course', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("game", data?.data?.enrollment?.classCount);
        setClassCount(data?.data?.enrollment?.classCount);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    let data = JSON.parse(userData);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      'https://quran-backend-theta.vercel.app/v1/user/student-attendance-course/678e62c9a50ef2d95a598ee1/67948b76f6a2e7acd0e5a2a8',
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log('Attendence', data?.attendanceRecords);

       
        const absentCount =
          data?.attendanceRecords?.filter((record) => record.status === 'Absent').length || 0;
        setAbsent(absentCount);
        
      })
      .catch((error) => console.error(error));
  }, []);

  const [reviews, setReviews] = useState(false);
  return (
    <StudentWrapper
      searchBar={
        <Input
          placeholder={`Search...`}
          Icon={
            <img
              src={require('../../../assets/image/Search-Magnifier.png')}
              className=" w-8"
              alt=""
            />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <AddPayment
        setIsModalOpen={setOpen}
        isModalOpen={open}
        signalId={courseDetails?.enrollment?._id}
      />

      <Reviews
        setIsModalOpen={setReviews}
        isModalOpen={reviews}
        setLoader={setLoader}
        setCourseDetails={setCourseDetails}
        signalId={courseDetails?.enrollment?._id}
      />

      <div className=" flex justify-between items-center ">
        <div>
          <h2 className="main_title ">{courseDetails?.course?.name}</h2>
          <p className=" text-[#1C1D1D]">Here are details of your Course</p>
        </div>
        <div></div>
      </div>

      <section className=" pt-2">
        <div className=" py-4  w-full grid  grid-cols-1  xl:grid-cols-2 md:grid-cols-2 gap-5">
          <div className=" w-full">
            <div
              className="  bg-white p-5 rounded-lg flex  justify-between"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Completed Lessons</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3  text-[#1C1D1D]">{classCount}</p>
                </div>
              </div>
              <div>
                <img src={require('../../../assets/image/completed.png')} alt="" />
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div
              className=" bg-white  flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Absents </h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{absent}</p>
                </div>
              </div>
              <div>
                <img src={require('../../../assets/image/absent.png')} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h1 className=" text-xl mt-4 text-[#1C1D1D] font-semibold">Cource Details</h1>
        {loader === true ? <Loader /> :(
          courseDetails?.enrollment?.status &&
            courseDetails.enrollment.status.charAt(0).toUpperCase() +
              courseDetails.enrollment.status.slice(1) ===
              'Completed' ? (
              <div
                className="p-3 mt-5 h-40 flex flex-col justify-center items-center rounded-lg"
                style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
              >
                <h2 className="text-lg text-[#1C1D1D] font-semibold mb-4">
                  Your course is completed. Please write a review.
                </h2>
                <button
                  onClick={() => {
                    setReviews(true);
                  }}
                  className="bg-secondary px-5 py-2.5 text-white text-center flex items-center gap-2 justify-center rounded-lg font-medium"
                >
                  Write Reviews
                </button>
              </div>
            ) : (
              <div
                className=" p-3 mt-5 rounded-lg"
                style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
              >
                <div className="flex  items-center  justify-between">
                  <div>
                    <span className="  text-gray-400 text-sm">Cource Name</span>
                    <h6 className="text-lg">
                      {courseDetails?.course?.name} (Status:{' '}
                      {courseDetails?.enrollment?.status &&
                        courseDetails.enrollment.status.charAt(0).toUpperCase() +
                          courseDetails.enrollment.status.slice(1)}
                      )
                    </h6>
                  </div>
                  <span>
                    <h6 className="text-lg">Time</h6>
                    {courseDetails?.assignment?.timeSlots?.map((item, index) => {
                      return (
                        <h6 className="text-lg">
                          {item?.startTime} To {item?.endTime}
                        </h6>
                      );
                    })}
                  </span>
                  <Link
                    to={`/documents/${courseDetails?.course?._id}?name=${encodeURIComponent(courseDetails?.course?.name)}`}
                    className="bg-[#007AFF] px-5 py-2.5 text-white text-center flex items-center gap-2 justify-center rounded-lg font-medium"
                  >
                    Documents
                  </Link>
                </div>
                <span className=" pt-3 m-0 text-gray-400 text-sm">Description</span>
                <h6 className="">{courseDetails?.course?.description}</h6>
    
                <ul className=" flex flex-col gap-2 mt-5">
                  <li>
                    <div className=" flex gap-1 items-center">
                      <div>
                        <img src={require('../../../assets/image/Graduation Cap.png')} alt="" />
                      </div>
                      <p>{courseDetails?.course?.lesson} Lessons</p>
                    </div>
                    <div className=" flex gap-1 items-center">
                      <div>
                        <h6 className="text-lg">Fee Due Date: </h6>
                      </div>
                      <p className="text-[green]">
                        {moment(courseDetails?.enrollment?.nextPaymentDate).format('MMM Do YY')}
                      </p>
                    </div>
                  </li>
                  <li>
                    <span className=" m-0 text-gray-400 text-sm">Price</span>
    
                    <p className=" pb-2">Rs {courseDetails?.course?.price}</p>
                    {courseDetails?.slip === null ? (
                      <button
                        onClick={() => setOpen(true)}
                        className="bg-[#007AFF] px-5 py-2.5 text-white text-center flex items-center gap-2 justify-center rounded-lg font-medium"
                      >
                        Pay Now
                      </button>
                    ) : moment(courseDetails?.enrollment?.nextPaymentDate).isValid() &&
                      moment().isAfter(moment(courseDetails?.enrollment?.nextPaymentDate)) ? (
                      <button
                        onClick={() => setOpen(true)}
                        className="bg-[#007AFF] px-5 py-2.5 text-white text-center flex items-center gap-2 justify-center rounded-lg font-medium"
                      >
                        Pay Now
                      </button>
                    ) : courseDetails?.slip?.status === 'waiting' ? (
                      <button
                        disabled
                        onClick={() => setOpen(true)}
                        className="bg-gray-400 px-5 py-2.5 text-white text-center flex items-center gap-2 justify-center rounded-lg font-medium"
                      >
                        Pending
                      </button>
                    ) : courseDetails?.slip?.status === 'paid' ? (
                      <button
                        onClick={() => setOpen(true)}
                        disabled
                        className="bg-gray-400 px-5 py-2.5 text-white text-center flex items-center gap-2 justify-center rounded-lg font-medium"
                      >
                        Paid
                      </button>
                    ) : null}
                  </li>
    
                  <li>
                    <span className=" m-0 text-gray-400 text-sm">Duration</span>
                    <p>
                      {courseDetails?.course?.duration} {courseDetails?.course?.periodType}
                    </p>
                  </li>
                </ul>
              </div>
            )
        )}
        
      </section>
    </StudentWrapper>
  );
};

export default EnrolledCourseDetails;
